import React from 'react';
import { FaWhatsapp, FaCar, FaCog, FaSearch, FaRocket, FaShieldAlt, FaClock, FaCheckCircle } from 'react-icons/fa';

const HomePage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge">
            <FaWhatsapp /> WhatsApp Powered
          </div>
          <h1>
            <span className="gradient-text">SPARE PARTS</span>
            <br />
            Auto Parts Booking System
          </h1>
          <p className="hero-subtitle">
            Your trusted partner for quality automotive spare parts in Kuwait. 
            Experience seamless part ordering through our automated WhatsApp booking system.
          </p>
          <div className="hero-buttons">
            <a href="https://wa.me/13613143794" className="btn-whatsapp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Order via WhatsApp
            </a>
            <a href="#services" className="btn-outline">
              Learn More
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">1000+</span>
              <span className="stat-label">Parts Available</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">WhatsApp Support</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">Fast</span>
              <span className="stat-label">Delivery</span>
            </div>
          </div>
        </div>
        <div className="hero-visual">
          <div className="floating-card card-1">
            <FaCar />
            <span>All Car Brands</span>
          </div>
          <div className="floating-card card-2">
            <FaCog />
            <span>OEM & Aftermarket</span>
          </div>
          <div className="floating-card card-3">
            <FaCheckCircle />
            <span>Quality Guaranteed</span>
          </div>
          <div className="car-graphic">
            🚗
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" id="services">
        <div className="section-header">
          <span className="section-badge">Our Services</span>
          <h2>Automated Part Booking System</h2>
          <p>Experience the future of auto parts ordering with our intelligent WhatsApp-powered system</p>
        </div>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">
              <FaWhatsapp />
            </div>
            <h3>WhatsApp Integration</h3>
            <p>Simply send us your car details and required parts via WhatsApp. Our automated system processes your request instantly.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <FaSearch />
            </div>
            <h3>Smart Part Search</h3>
            <p>Our AI-powered system identifies the exact parts you need based on your vehicle make, model, and year.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <FaRocket />
            </div>
            <h3>Instant Quotes</h3>
            <p>Receive competitive quotes from multiple trusted vendors within minutes, not hours.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <FaShieldAlt />
            </div>
            <h3>Quality Assurance</h3>
            <p>All parts are sourced from verified vendors ensuring genuine quality and warranty coverage.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <FaClock />
            </div>
            <h3>24/7 Availability</h3>
            <p>Our automated system works around the clock. Place orders anytime, get responses immediately.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <FaCar />
            </div>
            <h3>All Brands Covered</h3>
            <p>From Toyota to Mercedes, Honda to BMW - we source parts for all major car manufacturers.</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="section-header">
          <span className="section-badge">How It Works</span>
          <h2>Order Parts in 3 Easy Steps</h2>
          <p>Getting the right parts has never been easier</p>
        </div>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Send Your Request</h3>
              <p>Message us on WhatsApp with your car details (make, model, year) and the parts you need.</p>
            </div>
          </div>
          <div className="step-connector"></div>
          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Receive Quotes</h3>
              <p>Our system automatically contacts verified vendors and compiles the best quotes for you.</p>
            </div>
          </div>
          <div className="step-connector"></div>
          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Get Your Parts</h3>
              <p>Choose your preferred quote, confirm the order, and receive your parts with fast delivery.</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about" id="about">
        <div className="about-content">
          <div className="about-text">
            <span className="section-badge">About Us</span>
            <h2>Your Trusted Auto Parts Partner in Kuwait</h2>
            <p>
              Located in the heart of Hawalli, SPARE PARTS has been serving the automotive community 
              with dedication and excellence. We understand that finding the right parts for your 
              vehicle can be time-consuming and frustrating.
            </p>
            <p>
              That's why we've revolutionized the process with our automated WhatsApp booking system. 
              Simply tell us what you need, and our intelligent system connects you with the best 
              vendors, ensuring you get quality parts at competitive prices.
            </p>
            <div className="about-features">
              <div className="about-feature">
                <FaCheckCircle />
                <span>Verified Vendors Network</span>
              </div>
              <div className="about-feature">
                <FaCheckCircle />
                <span>Competitive Pricing</span>
              </div>
              <div className="about-feature">
                <FaCheckCircle />
                <span>Fast Turnaround</span>
              </div>
              <div className="about-feature">
                <FaCheckCircle />
                <span>Customer Support</span>
              </div>
            </div>
          </div>
          <div className="about-visual">
            <div className="about-card">
              <div className="about-card-icon">🔧</div>
              <h4>Expert Knowledge</h4>
              <p>Years of experience in the automotive parts industry</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="cta-content">
          <h2>Ready to Find Your Parts?</h2>
          <p>Contact us now on WhatsApp and experience the easiest way to order auto parts</p>
          <a href="https://wa.me/13613143794" className="btn-whatsapp-large" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp />
            <span>+1 (361) 3143794</span>
          </a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;




